import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { clearLocalStorage } from './helpers';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterModule]
})
export class AppComponent {
  title = 'app-login';

  constructor() {
    clearLocalStorage();
  }
}
